import React from 'react'

export default function TerminatePage() {
  return (
        <div style={{position:"absolute",top:"50%",left:"50%",padding:"10px",transform:"translate(-50%, -50%)",fontSize:"30px",fontWeight:"700"}} >
    <center>Visioconférence terminée</center>
    </div>
  )
}
